import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from 'features/SnackbarManager/actions'
import { Snackbar } from 'features/SnackbarManager/components/Snackbar'
import { SNACKBAR_FADE_DURATION } from 'features/SnackbarManager/constants'
import { selectSnackbars } from 'features/SnackbarManager/selectors'
import styles from './styles.module.sass'

export const SnackbarManager = () => {
  const dispatch = useDispatch()
  const snackbars = useSelector(selectSnackbars)
  const current = snackbars?.at(-1)
  const [fadeOut, setFadeOut] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const handleSnackbarAction = (id: string, callback?: () => void) => {
    callback?.()
    dispatch(actions.removeSnackbar(id))
  }

  const clearOldSnackbars = () => {
    if (!snackbars || snackbars.length <= 1) return
    const allButLast = snackbars.slice(0, -1)
    allButLast.forEach((snackbar) => {
      handleSnackbarAction(snackbar.id, snackbar.onTimeout)
    })
  }

  useEffect(() => {
    if (current) {
      clearOldSnackbars()
    }
  }, [current])

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  if (!current) return null

  return (
    <Snackbar
      key={current.id}
      message={current.message}
      actionLabel={current.actionLabel}
      onAction={(onAfter) => {
        setFadeOut(true)
        timeoutRef.current = setTimeout(() => {
          handleSnackbarAction(current.id, current.onAction)
          setFadeOut(false)
          onAfter()
        }, SNACKBAR_FADE_DURATION)
      }}
      onTimeout={() => {
        handleSnackbarAction(current.id, current.onTimeout)
      }}
      snackbarStyles={fadeOut ? styles.snackbarHidden : styles.snackbarVisible}
    />
  )
}
